// shadcn Button + loading-state. Source: stage-4-screens.md §4.

import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function SubmitButton({
  children,
  isPending,
  disabled,
  className,
}: {
  children: ReactNode;
  isPending?: boolean;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <Button
      type="submit"
      disabled={disabled || isPending}
      className={cn('h-10 w-full text-sm font-semibold', className)}
    >
      {isPending && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </Button>
  );
}
